import React, { useEffect, useState, useRef, useMemo } from "react";
import { getGoalComments } from "../../api/getComments";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../component/Pagination";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button,
  TextField,
  Modal,
  Link,
  Skeleton,
  Chip,
  IconButton,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import CheckBox from "../../component/CheckBox";
import LisitingSkeleton from "../../pages/common/LisitingSkeleton";
import { validateYupSchema } from "formik";
import moment from "moment/moment";
import axios from "axios";
import { isArray } from "jquery";
import CommentComponent from "../admin/modalsComponents/CommentComponent";
import CommentWrapper from "../admin/modalsComponents/CommentWrapper";

const goalCommentsCol = [
  { id: "goal_select", label: "", minWidth: 0, cls: "goal_select " },
  { id: "goal_comment", label: "COMMENT", minWidth: 105, cls: "goal_Comment" },
  { id: "user", label: "POSTED BY", minWidth: 0, cls: "commented_user" },
  { id: "date", label: "POSTED ON", minWidth: 0, cls: "posted_on" },

  {
    id: "goal_action_comments",
    label: "ACTIONS",
    minWidth: 0,
    cls: "goal_actions_comments",
  },
  { id: "replies", label: "REPLIES", minWidth: 0, cls: "replies" },
];

const goalCommentsRepliesCol = [
  { id: "goal_select", label: "", minWidth: 0, cls: "goal_select " },
  { id: "goal_comment", label: "COMMENT", minWidth: 105, cls: "goal_Comment" },
  { id: "user", label: "POSTED BY", minWidth: 0, cls: "commented_user" },
  { id: "date", label: "POSTED ON", minWidth: 0, cls: "posted_on" },

  { id: "goal_action", label: "ACTIONS", minWidth: 0, cls: "goal_actions" },
];

const ViewGoalComments = ({ setOpen, open, selectedGoal }) => {
  // "";
  const [goalComments, setGoalComments] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.auth.token);
  const [replies, setReplies] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const multipleSelect = useRef(new Map());
  const [selectall, setSelectAll] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const [openMulitDelete, setOpenMulitDelete] = useState(false);

  const fetchGoalComments = useMemo(
    () =>
      async (id, token, page = 1) => {
        try {
          setLoading(true);
          const data = await getGoalComments(id, token, page);
          // "";
          if (data?.success) {
            // setGoalComments();
            setGoalComments(data?.data?.data);
            // setLoading(false);
            setCurrentPage(data?.data?.currentPage);
            setTotalPages(Math.ceil(data?.data?.totalCount / 10));
          } else {
            toast.error(data.message);
          }
        } catch (err) {
          toast.error(err.message);
        } finally {
          setLoading(false);
        }
      },
    []
  );

  useEffect(() => {
    if (open && selectedGoal.current && token) {
      fetchGoalComments(selectedGoal.current.id, token);
    }
  }, [open]);

  const handleChangePage = (event, newPage) => {
    fetchGoalComments(selectedGoal.current.id, token, newPage);
  };

  async function handleGoalCommentDelete() {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/deleteComment/${deleteSelected.current.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        fetchGoalComments(selectedGoal.current.id, token, currentPage);
        toast.success("Comment deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  async function handleMultipleDelete() {
    try {
      const ids = Array.from(multipleSelect.current.entries()).map(
        (ele) => ele[0]
      );
      if (ids.length == 0) {
        toast.error("Please select at least one comment");
        multipleSelect.current.clear();
        return;
      }
      // const response = await axios.post(
      //   `${process.env.REACT_APP_API_URL}/deleteMultipleGoals`,
      //   {
      //     ids,
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
      // if (response.data.success) {
      //   dispatch(fetchGoalData(token, "", currentPage));
      //   toast.success("Selected videos deleted successfully");
      // }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenMulitDelete(false);
    }
  }

  // "";

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="assing-vote-modal view-comments">
          <Box className="title" sx={{ display: "flex" }}>
            <Typography component="h2" sx={{ flexGrow: "1" }}>
              Comments
            </Typography>
            {/* <IconButton onClick={() => handleMultipleDelete()}>
              <img src={DeleteIcon} alt="deleteIcon" />
            </IconButton> */}
          </Box>
          <Box className="content comment-content">
            {/* <Box className="page_table comment_table">
              <TableContainer component={Paper} className="customer_form">
                <Table
                  aria-label="leads table"
                  id="leadsTable"
                  style={{ width: "100%" }}
                >
                  <TableHead className="table_Head">
                    <TableRow key="goal_tb_head">
                      {goalCommentsCol.map((column) =>
                        column.id != "goal_select" ? (
                          <TableCell key={column.id} className={column.cls}>
                            {column.label}
                          </TableCell>
                        ) : (
                          <TableCell key={column.id}>
                            <input
                              type="checkbox"
                              className="siteCheckBox"
                              checked={selectall}
                              onChange={(e) => {
                                if (!e.target.checked) {
                                  multipleSelect.current.clear();
                                }
                                setSelectAll(e.target.checked);
                              }}
                            />
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      Array.from({ length: 10 }).map((e, i) => (
                        <TableRow>
                          <TableCell>
                            <Skeleton
                              variant="rectangular"
                              width={20}
                              height={20}
                            />
                          </TableCell>
                          <TableCell>
                            <Skeleton
                              variant="text"
                              sx={{ fontSize: "1rem" }}
                            />
                          </TableCell>
                          <TableCell>
                            <Skeleton
                              variant="text"
                              sx={{ fontSize: "1rem" }}
                            />
                          </TableCell>
                          <TableCell>
                            <Skeleton
                              variant="text"
                              sx={{ fontSize: "1rem" }}
                            />
                          </TableCell>
                          <TableCell align="middle">
                            <Skeleton
                              variant="rectangular"
                              width={40}
                              height={40}
                              sx={{ marginLeft: "25px" }}
                            />
                          </TableCell>
                          <TableCell>
                            <Skeleton
                              variant="text"
                              sx={{ fontSize: "1rem" }}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : Array.isArray(goalComments) &&
                      goalComments.length > 0 ? (
                      goalComments.map((value, index) => (
                        <>
                          <TableRow key={index}>
                            <TableCell align="center">
                              <CheckBox
                                multipleSelect={multipleSelect}
                                selectall={selectall}
                                data={value}
                                key={value.id}
                              />
                            </TableCell>

                            <TableCell align="center">
                              <Box className="tb-cell">
                                <Box className="p_image">
                                  {value?.comment_text}
                                </Box>
                              </Box>
                            </TableCell>

                            <TableCell>
                              <Box className="tb-cell">
                                <Typography
                                  variant="h4"
                                  component="h4"
                                  className="cus_title"
                                >
                                  {value?.commentUserDetails?.firstname +
                                    " " +
                                    value?.commentUserDetails?.lastName}
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell align="center">
                              <Box className="tb-cell">
                                <Typography
                                  variant="p"
                                  component="p"
                                  className="table-text"
                                >
                                  {moment(value?.createdAt).format(
                                    "MMM D,YYYY h:mm a"
                                  )}
                                </Typography>
                              </Box>
                            </TableCell>

                            <TableCell align="center">
                              <Box className="tb-cell">
                                <Box className="">
                                  <Button
                                    variant="text"
                                    onClick={() => {
                                      deleteSelected.current = value;
                                      setOpenDelete(true);
                                    }}
                                  >
                                    <img src={DeleteIcon} alt="" />
                                  </Button>
                                </Box>
                              </Box>
                            </TableCell>

                            <TableCell align="center">
                              <Box className="tb-cell">
                                <Typography
                                  variant="p"
                                  component="p"
                                  className="table-text"
                                >
                                  {value?.commentReplies.length}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </>
                      ))
                    ) : (
                      <TableRow component={`tr`}>
                        <TableCell colSpan={5} style={{ textAlign: "center" }}>
                          No Comment Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handleChangePage={handleChangePage}
                />
              )}
            </Box> */}

            <Box className="goal-details">
              <Typography component="h2">
                {selectedGoal.current?.title}
              </Typography>
              <Box className="user-details">
                {/* <Typography component="p">
                  Uploaded By :{" "}
                  {selectedGoal.current?.goalUserDetails?.firstName +
                    "  " +
                    selectedGoal.current?.goalUserDetails?.lastName}
                </Typography> */}
                <Chip
                  label={
                    selectedGoal.current?.goalUserDetails?.firstName +
                    "  " +
                    selectedGoal.current?.goalUserDetails?.lastName
                  }
                  variant="outlined"
                />
                {/* <Typography component="p">
                  Uploaded On{" "}
                  {moment(selectedGoal.current?.createdAt).format(
                    "MMM D,YYYY h:mm a"
                  )}
                </Typography> */}

                <Chip
                  label={moment(selectedGoal.current?.createdAt).format(
                    "MMM D,YYYY h:mm a"
                  )}
                  variant="outlined"
                />
              </Box>
            </Box>

            <Box className="comment-section">
              {loading ? (
                <Box>
                  {Array.from({ length: 10 }).map(() => (
                    <Skeleton
                      variant="rectangle"
                      // height={"50px"}
                      // width={"100%"}
                      sx={{
                        height: "50px",
                        borderRadius: "14px",
                        width: "100%",
                        marginBottom: "5px",
                      }}
                    />
                  ))}
                </Box>
              ) : isArray(goalComments) && goalComments.length > 0 ? (
                goalComments.map((ele) => (
                  <CommentWrapper
                    comment={ele}
                    setOpenDelete={setOpenDelete}
                    deleteSelected={deleteSelected}
                  />
                ))
              ) : (
                "No Comments"
              )}
            </Box>
          </Box>
          <Box className="actions">
            <Box className="action-wrapper">
              <Button
                onClick={() => {
                  setOpen(false);
                }}
              >
                Exit
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* delete comment */}
      <Modal
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete this comment.
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpenDelete(false)}>
              cancel
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                handleGoalCommentDelete(deleteSelected);
                setOpenDelete(false);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* delete multiple comment  */}

      <Modal
        open={openMulitDelete}
        onClose={() => setOpenMulitDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete the selected comments.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenMulitDelete(false)}
            >
              cancel
            </Button>
            <Button variant="outlined" onClick={handleMultipleDelete}>
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ViewGoalComments;
